import React, {useState, useEffect, Component} from 'react';
import {Provider, connect} from "react-redux";
import classNames from 'classnames';
import {Route} from 'react-router-dom';
import {auth} from "../src/actions";
import portalApp from "./reducers";
import {createStore, applyMiddleware} from "redux";
import thunk from "redux-thunk";
import AppTopBar from './AppTopbar';
import AppFooter from './AppFooter';
import AppConfig from './AppConfig';
import AppMenu from './AppMenu';
import AppSearch from './AppSearch';
import AppRightMenu from './AppRightMenu';
import Dashboard from './components/Dashboard.jsx';
import Register from "./pages/authentication/Register";
import Login from "./pages/authentication/Login";
import ResetPassword from "./pages/authentication/ResetPassword"
import User from './pages/userpages/User';
import UserList from './pages/userpages/UserList';
import RoleManagement from './pages/rolemanagement/RoleManagement';
import LogManagement from './pages/logmanagement/LogManagement';
import Inst_Dept from './pages/userpages/Inst_Dept';
import GeneralSettings from "./pages/generalsettings/GeneralSettings";
import ModuleManagement from "./pages/modulemanagement/ModuleManagement";
import CmsPage from "./pages/cmsmanagement/CmsPage";
import CmsContent from "./pages/cmsmanagement/CmsContent";
import CmsCategory from "./pages/cmsmanagement/CmsCategory";
import CmsContentList from "./pages/cmsmanagement/CmsContentList";
import UserProfile from "./pages/userpages/UserProfile";
import CmsPageList from "./pages/cmsmanagement/CmsPageList";
import CmsContentStatistic from "./pages/cmsmanagement/CmsContentStatistic";
import CmsSendMail from "./pages/cmsmanagement/CmsSendMail";
import SSSAdd from "./pages/modulemanagement/SSSAdd";
import SSSList from "./pages/modulemanagement/SSSList";
import ModuleSubscription from "./pages/modulemanagement/ModuleSubScription";
import ReportManagement from "./pages/reportmanagement/ReportManagement"
import MessageList from "./pages/messageManagement/MessageList";
import MessageDetail from "./pages/messageManagement/MessageDetail"
import ModuleSubScriptionCancellation from "./pages/modulemanagement/ModuleSubScriptionCancellation";
import Spinner from "./spinner/Spinner";
import PrimeReact from 'primereact/api';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.scss';
import CancelMail from "./pages/CancelMail"
import Reservations from "./pages/systemmanagement/Reservations";
import Server from "./pages/cloudmanagement/Server";
import Flavors from "./pages/cloudmanagement/Flavors";
import Volumes from "./pages/cloudmanagement/Volumes";
import Images from "./pages/cloudmanagement/Images";
import Sources from "./pages/cloudmanagement/Sources";
import SourceConfiguration from "./pages/cloudmanagement/SourceConfiguration";
import MyReservations from "./pages/systemmanagement/My-Reservations";
import LoanRequest from "./pages/systemmanagement/LoanRequest";
import ReservationRequest from "./pages/systemmanagement/ReservationRequest";
import MyCreditApplications from "./pages/systemmanagement/My-CreditApplications";
import CreditApplications from "./pages/systemmanagement/CreditApplications";
import MyCreditHistory from "./pages/systemmanagement/My-CreditHistory";
import CreditHistory from "./pages/systemmanagement/CreditHistory";
import UserCredits from "./pages/systemmanagement/UserCredits";
import ModuleReservationAdd from "./pages/modulemanagement/ModuleReservationAdd";
import ModuleReservations from "./pages/modulemanagement/ModuleReservations";
import MyModuleReservations from "./pages/modulemanagement/MyModuleReservations";
import Notification from "./pages/notificationmanagement/Notification";
import GpuRoleManagement from "./pages/modulemanagement/GpuRoleManagement";

let store = createStore(portalApp, applyMiddleware(thunk));

const RootContainerComponent = props => {
    const [mesaj, setMesaj] = useState([]);
    const [menuActive, setMenuActive] = useState(false);
    const [menuMode, setMenuMode] = useState('static');
    const [colorScheme, setColorScheme] = useState('light');
    const [menuTheme, setMenuTheme] = useState('layout-sidebar-darkgray');
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(false);
    const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
    const [searchActive, setSearchActive] = useState(false);
    const [topbarUserMenuActive, setTopbarUserMenuActive] = useState(false);
    const [topbarNotificationMenuActive, setTopbarNotificationMenuActive] = useState(false);
    const [rightMenuActive, setRightMenuActive] = useState(false);
    const [configActive, setConfigActive] = useState(false);
    const [inputStyle, setInputStyle] = useState('outlined');
    const [ripple, setRipple] = useState(false);
    const [logoColor, setLogoColor] = useState('white');
    const [componentTheme, setComponentTheme] = useState('blue');
    const [logoUrl, setLogoUrl] = useState('assets/layout/images/logo-dark.svg')
    const contentAddRole = !!localStorage.getItem('cms_add');
    const content_list_role = !!localStorage.getItem('cms_list');
    const statistic_list_role = !!localStorage.getItem('statistic_list_role');
    const category_add_role = !!localStorage.getItem('category_list');
    const user_add_role = !!localStorage.getItem('user_add');
    const user_list_role = !!localStorage.getItem('user_list');
    const inst_list_role = !!localStorage.getItem('inst_list');
    const roleListRole = !!localStorage.getItem('role_list');
    const logListRole = !!localStorage.getItem('log_list');
    const sss_add_role = !!localStorage.getItem('sss_add');
    const sss_list_role = !!localStorage.getItem('sss_list');
    const reportListRole = !!localStorage.getItem('report_list');
    const messagesAddRole = !!localStorage.getItem('messages_add');
    const md_user_list_role = !!localStorage.getItem('md_user_list');
    const send_mail_role = !!localStorage.getItem('send_mail');
    const image_list_role = !!localStorage.getItem('cloud_image_list');
    const flavor_list_role = !!localStorage.getItem('cloud_flavor_list');
    const source_list_role = !!localStorage.getItem('cloud_source_list');
    const credit_approver_role = !!localStorage.getItem('credit_approver');
    const reservation_approver_role = !!localStorage.getItem('reservation_approver');
    const cloud_configuration_role = !!localStorage.getItem('cloud_configuration');
    const module_usage_approval = !!localStorage.getItem('module_usage_approval');

    const user_management_role = user_add_role || user_list_role || inst_list_role;
    const sss_management_role = sss_add_role || sss_list_role;
    const management_module_role = user_management_role || roleListRole || logListRole || sss_management_role;
    const content_management_role = contentAddRole || content_list_role || statistic_list_role || category_add_role;

    let menuClick = false;
    let searchClick = false;
    let userMenuClick = false;
    let notificationMenuClick = false;
    let rightMenuClick = false;
    let configClick = false;

    const messagesget = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/messages/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;
                        if (data) {
                            setMesaj(data.result)

                        } else {
                            // this.setState({disable_submit_btn: false});
                        }
                    } else if (res.status === 401 || res.status === 403) {
                        throw res.data;
                    }
                })
        }
    }

    useEffect(() => {
        messagesget();
    }, []);

    useEffect(() => {
        // console.log(props.auth.isAuthenticated)
    }, [props.auth.isAuthenticated]);

    const menu = [
        {
            label: "ANASAYFA", icon: "pi pi-fw pi-home",
            items: [
                {label: "Anasayfa", icon: "pi pi-fw pi-home", to: "/main"}
            ]
        },


        {
            label: "Yönetim Modülü", icon: "pi pi-fw pi-id-card",

            items: [
                {
                    label: "Kullanıcı Yönetimi", icon: "pi pi-fw pi-id-card",
                    style: {display: user_add_role ? 'block' : user_list_role ? 'block' : inst_list_role ? 'block' : 'none'},
                    items: [
                        // {
                        //     label: "Kullanıcı Ekleme", icon: "pi pi-user-plus", to: "/user",
                        //     style: {display: user_add_role ? 'block' : 'none'},
                        // },
                        {
                            label: "Kullanıcılar", icon: "pi pi-user", to: "/users",
                            style: {display: user_list_role ? 'block' : 'none'},
                        },
                        {
                            label: "Kurum ve Departmanlar", icon: "pi pi-briefcase", to: "/inst_dept",
                            style: {display: inst_list_role ? 'block' : 'none'},
                        },

                    ]
                },

                {
                    label: "Rol Yönetimi",
                    icon: "pi pi-key",
                    to: "/role-management",
                    style: {display: roleListRole ? 'block' : 'none'}
                },
                {
                    label: "Log Yönetimi",
                    icon: "pi pi-list",
                    to: "/log-management",
                    style: {display: logListRole ? 'block' : 'none'}
                },
                {
                    label: "SSS Yönetimi", icon: "pi pi-info-circle",
                    style: {display: sss_add_role ? 'block' : sss_list_role ? 'block' : 'none'},
                    items: [
                        {
                            label: "SSS Ekleme",
                            icon: "pi pi-plus",
                            to: "/sssAdd",
                            style: {display: sss_add_role ? 'block' : 'none'}
                        },
                        {
                            label: "SSS Listesi",
                            icon: "pi pi-sort-alt",
                            to: "/sss",
                            style: {display: sss_list_role ? 'block' : 'none'}
                        },


                    ]
                },
                {
                    label: 'Raporlama Yönetimi',
                    icon: 'pi pi-list ',
                    style: {display: reportListRole ? 'block' : 'none'},
                    command: () => {
                        window.location.hash = "/report-management"
                    }
                },
                {
                    label: 'Mesajlaşma Yönetimi',
                    badge: "4",
                    icon: 'pi pi-comment ',
                    style: {display: messagesAddRole ? 'block' : 'none'},
                    command: () => {
                        window.location.hash = "/message"
                    }
                },
                {
                    label: "GPU Talep Yönetimi",
                    icon: "pi pi-server",
                    to: "/gpu-role-management",
                    style: {display: module_usage_approval ? 'block' : 'none'}
                },


            ],
        },
        {
            label: "İçerik Yönetimi", icon: "pi pi-calendar-times",

            items: [
                {
                    label: "İçerik Ekleme",
                    icon: "pi pi-plus",
                    to: "/content",
                    style: {display: contentAddRole ? 'block' : 'none'}
                },
                {
                    label: "İçerik Listesi",
                    icon: "pi pi-list",
                    to: "/contents",
                    style: {display: content_list_role ? 'block' : 'none'}
                },
                {
                    label: "İçerik İstatistikleri",
                    icon: "pi pi-chart-bar",
                    to: "/statistic",
                    style: {display: statistic_list_role ? 'block' : 'none'}
                },
                {
                    label: "İçerik Kategorileri",
                    icon: "pi pi-sort-amount-down-alt",
                    to: "/category",
                    style: {display: category_add_role ? 'block' : 'none'}
                },

            ]
        },


        {
            label: "Rezervasyon Sistemi", icon: "pi pi-cloud-upload",

            items: [
                {
                    label: "Kredi Yönetimi", icon: "pi pi-calendar-times",

                    items: [
                        {
                            label: "Kredi Talebi Oluştur",
                            icon: "pi pi-plus",
                            to: "/loanrequest",
                        },
                        {
                            label: "Kredi Talepleri",
                            icon: "pi pi-check-circle",
                            to: "/creditapplications",
                            style: {display: credit_approver_role ? 'block' : 'none'}
                        },
                        {
                            label: "Kredi Taleplerim",
                            icon: "pi pi-check-circle",
                            to: "/my-creditapplications",
                        },
                        {
                            label: "Kullanıcı Kredi Harcamaları",
                            icon: "pi pi-clock",
                            to: "/credithistories",
                            style: {display: credit_approver_role ? 'block' : 'none'}
                        },
                        {
                            label: "Kredi Harcamalarım",
                            icon: "pi pi-clock",
                            to: "/my-credithistories",

                        },
                        {
                            label: "Kullanıcı Kaynak Limitleri",
                            icon: "pi pi-chart-bar",
                            to: "/usercredits",
                            style: {display: cloud_configuration_role ? 'block' : 'none'}
                        },


                    ]
                },
                {
                    label: "Rezervasyon Yönetimi", icon: "pi pi-clock", style: {fontSize: '0.9rem'},

                    items: [
                        {
                            label: "Rezervasyon Talebi Oluştur",
                            icon: "pi pi-plus",
                            to: "/reservationrequest",
                        },
                        {
                            label: "Rezervasyon Talepleri",
                            icon: "pi pi-check-circle",
                            to: "/reservations",
                            style: {display: reservation_approver_role ? 'block' : 'none'}
                        },
                        {
                            label: "Rezervasyonlarım",
                            icon: "pi pi-clock",
                            to: "/my-reservations",
                        },


                    ]
                },
                {
                    label: "Sunucu Yönetimi", icon: "pi pi-clock", style: {fontSize: '0.9rem'},

                    items: [
                        {
                            label: "Sunucular",
                            icon: "pi pi-cloud",
                            to: "/server",

                        },
                        {
                            label: "Konfigürasyon",
                            icon: "pi pi-cog",
                            to: "/cloud-configuration",
                            style: {display: cloud_configuration_role ? 'block' : 'none'}
                        },
                        {
                            label: "Kaynaklar",
                            icon: "pi pi-chart-line",
                            to: "/cloud-sources",
                            style: {display: source_list_role ? 'block' : 'none'}
                        },


                        {
                            label: "Şablonlar",
                            icon: "pi pi-sliders-v",
                            to: "/cloud-flavors",
                            style: {display: flavor_list_role ? 'block' : 'none'}
                        },
                        {
                            label: "İmajlar",
                            icon: "pi pi-tags",
                            to: "/cloud-images",
                            style: {display: image_list_role ? 'block' : 'none'}
                        },


                    ]
                },


            ]
        },
        {
            label: "Portal Yönetimi",
            icon: "pi pi-calendar-times",

            items: [
                {
                    label: "Portal Kullanım Başvurusu Oluştur",
                    icon: "pi pi-fw pi-id-card",
                    to: "/md-reservation",
                    style: {display: roleListRole ? 'none' : 'block'}
                },
                {
                    label: "Kullanım Başvuruları",
                    icon: "pi pi-list",
                    to: "/md-reservations",
                    style: {display: module_usage_approval ? 'block' : 'none'}
                },
                {
                    label: "Portal Kullanım Başvurularım",
                    icon: "pi pi-list",
                    to: "/my-md-reservations",
                    style: {display: roleListRole ? 'none' : 'block'}
                },

            ]
        },
        {
            label: "e-Bülten Yönetimi", icon: "pi pi-calendar-times",

            items: [
                {
                    label: "Kayıtlı Kullanıcılar",
                    icon: "pi pi-list",
                    to: "/md-subscription",
                    style: {display: md_user_list_role ? 'block' : 'none'}
                },
                {
                    label: "e-Bülten Mail Oluştur",
                    icon: "pi pi-comments",
                    to: "/mail",
                    style: {display: send_mail_role ? 'block' : 'none'}
                },
                {
                    label: "e-Bülten Kayıt İptali",
                    icon: "pi pi-times",
                    to: "/cancellation",
                },
            ]
        },


    ];

    const routers = [
        {
            path: '/main',
            component: Dashboard,
            exact: true,
            meta: {breadcrumb: [{parent: 'Dashboard', label: 'Ana Sayfa'}]}
        },
        {path: '/', component: Login, exact: true, meta: {breadcrumb: [{parent: 'UI Kit', label: 'Ana Sayfa'}]}},
        {path: '/login', component: Login, meta: {breadcrumb: [{parent: 'UI Kit', label: 'Giriş'}]}},
        {path: '/user', component: User, meta: {breadcrumb: [{parent: 'UI Kit', label: 'Kullanıcı Ekleme'}]}},
        // {path: '/:id',  children: User, meta: {breadcrumb: [{parent: 'UI Kit', label: 'Kullanıcı Ekleme'}]}},
        {path: '/users', component: UserList, meta: {breadcrumb: [{parent: 'UI Kit', label: 'Kullanıcılar'}]}},
        {
            path: '/inst_dept',
            component: Inst_Dept,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'Kurum ve Departmanlar'}]}
        },
        {path: '/register', component: Register, meta: {breadcrumb: [{parent: 'UI Kit', label: 'Kullanici Kayıt'}]}},
        {
            path: '/role-management',
            component: RoleManagement,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'Rol Yönetimi'}]}
        },
        {
            path: '/log-management',
            component: LogManagement,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'Log Yönetimi'}]}
        },
        {
            path: '/module-management',
            component: ModuleManagement,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'Modül Yönetimi'}]}
        },
        {path: '/content', component: CmsContent, meta: {breadcrumb: [{parent: 'UI Kit', label: 'İÇERİK EKLEME'}]}},
        {path: '/:cont_id', children: CmsContent, meta: {breadcrumb: [{parent: 'UI Kit', label: 'İÇERİK'}]}},
        {
            path: '/contents',
            component: CmsContentList,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'İÇERİK LİSTESİ'}]}
        },
        {
            path: '/category',
            component: CmsCategory,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'KATEGORİLER'}]}
        },
        {path: '/intro-page', component: CmsPage, meta: {breadcrumb: [{parent: 'UI Kit', label: 'Sayfa Ekleme'}]}},
        {
            path: '/:action_type/:cip_id',
            children: CmsPage,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'Sayfa Düzenleme'}]}
        },
        {
            path: '/pages',
            component: CmsPageList,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'Sayfalar'}]}
        }, {
            path: '/statistic',
            component: CmsContentStatistic,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'İÇERİK İSTATİSTİKLERİ'}]}
        }, {
            path: '/mail',
            component: CmsSendMail,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'e-Bülten MAİL GÖNDER'}]}
        },
        {
            path: '/sssAdd',
            component: SSSAdd,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'SIKÇA SORULAN SORU EKLEME'}]}
        },


        {
            path: '/:faq_id',
            children: SSSAdd,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'SIKÇA SORULAN SORU EKLEME'}]}
        },
        {
            path: '/sss',
            component: SSSList,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'SIKÇA SORULAN SORULAR'}]}
        }, {
            path: '/md-subscription',
            component: ModuleSubscription,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'KAYITLI KULLANICILAR'}]}
        },
        {
            path: '/cancellation',
            component: ModuleSubScriptionCancellation,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'e-Bülten KAYIT İPTALİ'}]}
        }, {
            path: '/report-management',
            component: ReportManagement,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'RAPORLAMA YÖNETİMİ'}]}
        },
        {
            path: "/message/detail",
            component: MessageDetail,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'MESAJLASMA YÖNETİMİ'}]}
        },
        {
            path: "/message",
            component: MessageList,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'MESAJLASMA YÖNETİMİ'}]}
        },
        {
            path: "/cancelmail/:id/:mail/:hash",
            component: CancelMail,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'e-Bülten iptal'}]}
        },
        {
            path: "/loanrequest",
            component: LoanRequest,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'Kredi Talebi Oluştur '}]}
        },
        {
            path: "/creditapplications",
            component: CreditApplications,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'Kredi Talepleri'}]}
        },
        {
            path: "/my-creditapplications",
            component: MyCreditApplications,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'Kredi Taleplerim'}]}
        },
        {
            path: "/credithistories",
            component: CreditHistory,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'Kullanıcı Kredi Harcamaları'}]}
        },
        {
            path: "/usercredits",
            component: UserCredits,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'Kullanıcı Kaynak Limitleri'}]}
        },
        {
            path: "/my-credithistories",
            component: MyCreditHistory,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'Kredi Harcamalarım'}]}
        },
        {
            path: "/reservationrequest",
            component: ReservationRequest,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'Rezervasyon Talebi Oluştur '}]}
        },
        {
            path: "/reservations",
            component: Reservations,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'Rezervasyon Talepleri'}]}
        },
        {
            path: "/my-reservations",
            component: MyReservations,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'Rezervasyonlarım'}]}
        },
        {
            path: "/server",
            component: Server,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'Sunucular'}]}
        },
        {
            path: "/cloud-configuration",
            component: SourceConfiguration,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'Konfigürasyon'}]}
        },
        {
            path: "/cloud-flavors",
            component: Flavors,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'Şablonlar'}]}
        },
        {
            path: "/cloud-images",
            component: Images,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'İmajlar'}]}
        },
        /*{
            path: "/cloud-volumes",
            component: Volumes,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'Mantıksal Sürücüler'}]}
        }, */
        {
            path: "/cloud-sources",
            component: Sources,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'Kaynaklar'}]}
        },
        {
            path: "/md-reservation",
            component: ModuleReservationAdd,
            meta: {breadcrumb: [{parent: 'UI Kit', label: 'Portal Kullanım Başvurusu'}]}
        },
        {
            path: "/md-reservations",
            component: ModuleReservations,
            meta: {breadcrumb: [{parent: 'UI Kit', label: ' Kullanım Başvuruları'}]}
        },
        {
            path: "/my-md-reservations",
            component: MyModuleReservations,
            meta: {breadcrumb: [{parent: 'UI Kit', label: ' Kullanım Başvurularım'}]}
        },
        {
            path: "/notifications",
            component: Notification,
            meta: {breadcrumb: [{parent: 'UI Kit', label: ' Bildirimlerim'}]}
        },


    ];

    useEffect(() => {
        if (staticMenuMobileActive) {
            blockBodyScroll();
        } else {
            unblockBodyScroll();
        }
        props.loadUser();
    }, [staticMenuMobileActive]);

    useEffect(() => {
        changeStyleSheetUrl('layout-css', 'layout-' + colorScheme + '.css', 1);
        changeStyleSheetUrl('theme-css', 'theme-' + colorScheme + '.css', 1);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const onInputStyleChange = (inputStyle) => {
        setInputStyle(inputStyle);
    };

    const changeMenuTheme = (name, logoColor, componentTheme) => {
        onMenuThemeChange(name);
        changeStyleSheetUrl('theme-css', componentTheme, 2);
        setComponentTheme(componentTheme)

        const appLogoLink = document.getElementById('app-logo');
        const appLogoUrl = `assets/layout/images/logo-${logoColor === 'dark' ? 'dark' : 'white'}.svg`;

        if (appLogoLink) {
            appLogoLink.src = appLogoUrl;
        }
        setLogoColor(logoColor);
    };

    const changeComponentTheme = (theme) => {
        setComponentTheme(theme)
        changeStyleSheetUrl('theme-css', theme, 3);
    };

    const changeColorScheme = (e) => {
        setColorScheme(e.value);

        const scheme = e.value;
        changeStyleSheetUrl('layout-css', 'layout-' + scheme + '.css', 1);
        changeStyleSheetUrl('theme-css', 'theme-' +
            '' + scheme + '.css', 1);
        changeLogo(scheme);
    };

    const changeStyleSheetUrl = (id, value, from) => {
        const element = document.getElementById(id);
        const urlTokens = element.getAttribute('href').split('/');

        if (from === 1) {
            // which function invoked this function
            urlTokens[urlTokens.length - 1] = value;
        } else if (from === 2) {
            // which function invoked this function
            if (value !== null) {
                urlTokens[urlTokens.length - 2] = value;
            }
        } else if (from === 3) {
            // which function invoked this function
            urlTokens[urlTokens.length - 2] = value;
        }

        const newURL = urlTokens.join('/');

        replaceLink(element, newURL);
    };

    const changeLogo = (scheme) => {
        const appLogoLink = document.getElementById("app-logo");
        const mobileLogoLink = document.getElementById("logo-mobile");
        const invoiceLogoLink = document.getElementById("invoice-logo");
        const footerLogoLink = document.getElementById("footer-logo");
        setLogoUrl(`assets/layout/images/logo-${scheme === 'light' ? 'dark' : 'white'}.svg`);

        if (appLogoLink) {
            appLogoLink.src = `assets/layout/images/logo-${scheme === 'light' ? logoColor : 'white'}.svg`;
        }

        if (mobileLogoLink) {
            mobileLogoLink.src = logoUrl;
        }

        if (invoiceLogoLink) {
            invoiceLogoLink.src = logoUrl;
        }

        if (footerLogoLink) {
            footerLogoLink.src = logoUrl;
        }
    };

    const replaceLink = (linkElement, href) => {
        if (isIE()) {
            linkElement.setAttribute("href", href);
        } else {
            const id = linkElement.getAttribute("id");
            const cloneLinkElement = linkElement.cloneNode(true);

            cloneLinkElement.setAttribute("href", href);
            cloneLinkElement.setAttribute("id", id + "-clone");

            linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);

            cloneLinkElement.addEventListener("load", () => {
                linkElement.remove();
                cloneLinkElement.setAttribute("id", id);
            });
        }
    };


    const isIE = () => {
        return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
    };


    const onRippleChange = (e) => {
        PrimeReact.ripple = e.value;
        setRipple(e.value);
    };

    const onDocumentClick = () => {
        if (!searchClick && searchActive) {
            onSearchHide();
        }

        if (!userMenuClick) {
            setTopbarUserMenuActive(false);
        }

        if (!notificationMenuClick) {
            setTopbarNotificationMenuActive(false);
        }

        if (!rightMenuClick) {
            setRightMenuActive(false);
        }

        if (!menuClick) {
            if (isSlim()) {
                setMenuActive(false);
            }

            if (overlayMenuActive || staticMenuMobileActive) {
                hideOverlayMenu();
            }

            unblockBodyScroll();
        }

        if (configActive && !configClick) {
            setConfigActive(false);
        }

        searchClick = false;
        configClick = false;
        userMenuClick = false;
        rightMenuClick = false;
        notificationMenuClick = false;
        menuClick = false;
    };

    const onMenuClick = () => {
        menuClick = true;
    };

    const onMenuButtonClick = (event) => {
        menuClick = true;
        setTopbarUserMenuActive(false);
        setTopbarNotificationMenuActive(false);
        setRightMenuActive(false);

        if (isOverlay()) {
            setOverlayMenuActive(prevOverlayMenuActive => !prevOverlayMenuActive);
        }

        if (isDesktop()) {
            setStaticMenuDesktopInactive(prevStaticMenuDesktopInactive => !prevStaticMenuDesktopInactive);
        } else {
            setStaticMenuMobileActive(prevStaticMenuMobileActive => !prevStaticMenuMobileActive);
        }

        event.preventDefault();
    };

    const onMenuitemClick = (event) => {
        if (!event.item.items) {
            hideOverlayMenu();

            if (isSlim()) {
                setMenuActive(false);
            }
        }
    };

    const onRootMenuitemClick = () => {
        setMenuActive(prevMenuActive => !prevMenuActive);
    };

    const onMenuThemeChange = (name) => {
        setMenuTheme('layout-sidebar-' + name);
    };

    const onMenuModeChange = (e) => {
        setMenuMode(e.value);
        if (e.value === 'static') {
            setStaticMenuDesktopInactive(false)
        }
    };


    const onTopbarUserMenuButtonClick = (event) => {
        userMenuClick = true;
        setTopbarUserMenuActive(prevTopbarUserMenuActive => !prevTopbarUserMenuActive);

        hideOverlayMenu();

        event.preventDefault();
    };

    const onTopbarNotificationMenuButtonClick = (event) => {
        notificationMenuClick = true;
        setTopbarNotificationMenuActive(prevTopbarNotificationMenuActive => !prevTopbarNotificationMenuActive);

        hideOverlayMenu();

        event.preventDefault();
    };

    const toggleSearch = () => {
        setSearchActive(prevSearchActive => !prevSearchActive);
        searchClick = true;
    };

    const onSearchClick = () => {
        searchClick = true;
    };

    const onSearchHide = () => {
        setSearchActive(false);
        searchClick = false;
    };

    const onRightMenuClick = () => {
        rightMenuClick = true;
    };

    const onRightMenuButtonClick = (event) => {
        rightMenuClick = true;
        setRightMenuActive(prevRightMenuActive => !prevRightMenuActive);
        hideOverlayMenu();
        event.preventDefault();
    };

    const onConfigClick = () => {
        configClick = true;
    };

    const onConfigButtonClick = () => {
        setConfigActive(prevConfigActive => !prevConfigActive);
        configClick = true;
    };

    const hideOverlayMenu = () => {
        setOverlayMenuActive(false);
        setStaticMenuMobileActive(false);
        unblockBodyScroll();
    };

    const blockBodyScroll = () => {
        if (document.body.classList) {
            document.body.classList.add('blocked-scroll');
        } else {
            document.body.className += ' blocked-scroll';
        }
    };

    const unblockBodyScroll = () => {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
                'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    };

    const isSlim = () => {
        return menuMode === "slim";
    };

    const isOverlay = () => {
        return menuMode === "overlay";
    };

    const isDesktop = () => {
        return window.innerWidth > 991;
    };

    const containerClassName = classNames('layout-wrapper',
        {
            'layout-overlay': menuMode === "overlay",
            'layout-static': menuMode === "static",
            'layout-slim': menuMode === "slim",
            'layout-sidebar-dim': colorScheme === "dim",
            'layout-sidebar-dark': colorScheme === "dark",
            'layout-overlay-active': overlayMenuActive,
            'layout-mobile-active': staticMenuMobileActive,
            'layout-static-inactive': staticMenuDesktopInactive && menuMode === "static",
            'p-input-filled': inputStyle === "filled",
            'p-ripple-disabled': !ripple,
        },
        colorScheme === 'light' ? menuTheme : '');
    // console.log("props:", props)
    if (props.auth.isAuthenticated) {

        const referrer_url = document.referrer;
        if (referrer_url.includes("module_id")) {
            const module_id = referrer_url.split('module_id=')[1];
            window.location.hash = "md-reservation?module_id=" + module_id;
        }

        return (
            <div className={containerClassName} data-theme={colorScheme} onClick={onDocumentClick}>
                <div className="layout-content-wrapper">
                    <AppTopBar routers={routers} topbarNotificationMenuActive={topbarNotificationMenuActive}
                               topbarUserMenuActive={topbarUserMenuActive} onMenuButtonClick={onMenuButtonClick}
                               onSearchClick={toggleSearch}
                               onTopbarNotification={onTopbarNotificationMenuButtonClick}
                               onTopbarUserMenu={onTopbarUserMenuButtonClick} onRightMenuClick={onRightMenuButtonClick}
                               onRightMenuButtonClick={onRightMenuButtonClick}>

                    </AppTopBar>

                    <div className="layout-content">
                        <Route exact path="/register" component={Register}/>
                        <Route exact path="/profil" component={UserProfile}/>
                        <Route exact path="/resetpassword" component={ResetPassword}/>
                        <Route exact path="/main" component={Dashboard}/>
                        <Route exact path="/" component={UserProfile}/>
                        <Route exact path="/user" component={User}/>
                        <Route exact path="/user/:id/" component={User}/>
                        <Route exact path="/users" component={UserList}/>
                        <Route exact path="/role-management" component={RoleManagement}/>
                        <Route exact path="/log-management" component={LogManagement}/>
                        <Route exact path="/inst_dept" component={Inst_Dept}/>
                        <Route exact path="/general-settings" component={GeneralSettings}/>
                        <Route exact path="/module-management" component={ModuleManagement}/>
                        <Route exact path="/content" component={CmsContent}/>
                        <Route exact path="/contents" component={CmsContentList}/>
                        <Route exact path="/content/:cont_id/" component={CmsContent}/>
                        <Route exact path="/category" component={CmsCategory}/>
                        <Route exact path="/pages" component={CmsPageList}/>
                        <Route exact path="/statistic" component={CmsContentStatistic}/>
                        <Route exact path="/intro-page" component={CmsPage}/>
                        <Route exact path="/intro-page/:action_type/:cip_id/" component={CmsPage}/>
                        <Route exact path="/mail" component={CmsSendMail}/>
                        <Route exact path="/sssAdd" component={SSSAdd}/>
                        <Route exact path="/sssAdd/:faq_id/" component={SSSAdd}/>
                        <Route exact path="/sss" component={SSSList}/>
                        <Route exact path="/md-subscription" component={ModuleSubscription}/>
                        <Route exact path="/report-management" component={ReportManagement}/>
                        <Route exact path="/message" component={MessageList}/>
                        <Route exact path="/message/detail" component={MessageDetail}/>
                        <Route exact path="/cancellation" component={ModuleSubScriptionCancellation}/>
                        <Route exact path="/cancellation/:result" component={ModuleSubScriptionCancellation}/>
                        <Route exact path="/cancelmail/:mail/:hash/" component={CancelMail}/>
                        <Route exact path="/reservations" component={Reservations}/>
                        <Route exact path="/my-reservations" component={MyReservations}/>
                        <Route exact path="/cloud-configuration" component={SourceConfiguration}/>
                        <Route exact path="/server" component={Server}/>
                        <Route exact path="/cloud-flavors" component={Flavors}/>
                        <Route exact path="/cloud-volumes" component={Volumes}/>
                        <Route exact path="/cloud-images" component={Images}/>
                        <Route exact path="/cloud-sources" component={Sources}/>
                        <Route exact path="/loanrequest" component={LoanRequest}/>
                        <Route exact path="/reservationrequest" component={ReservationRequest}/>
                        <Route exact path="/creditapplications" component={CreditApplications}/>
                        <Route exact path="/my-creditapplications" component={MyCreditApplications}/>
                        <Route exact path="/credithistories" component={CreditHistory}/>
                        <Route exact path="/my-credithistories" component={MyCreditHistory}/>
                        <Route exact path="/usercredits" component={UserCredits}/>
                        <Route exact path="/md-reservation" component={ModuleReservationAdd}/>
                        <Route exact path="/md-reservations" component={ModuleReservations}/>
                        <Route exact path="/my-md-reservations" component={MyModuleReservations}/>
                        <Route exact path="/notifications" component={Notification}/>
                        <Route exact path="/gpu-role-management" component={GpuRoleManagement}/>


                    </div>

                    <AppFooter/>
                </div>

                <AppMenu model={menu} menuMode={menuMode} active={menuActive} mobileMenuActive={staticMenuMobileActive}
                         onMenuClick={onMenuClick} onMenuitemClick={onMenuitemClick}
                         onRootMenuitemClick={onRootMenuitemClick}>

                </AppMenu>

                <AppRightMenu rightMenuActive={rightMenuActive} onRightMenuClick={onRightMenuClick}>

                </AppRightMenu>

                <AppConfig configActive={configActive} menuMode={menuMode} onMenuModeChange={onMenuModeChange}
                           colorScheme={colorScheme} changeColorScheme={changeColorScheme} menuTheme={menuTheme}
                           changeMenuTheme={changeMenuTheme}
                           componentTheme={componentTheme} changeComponentTheme={changeComponentTheme}
                           onConfigClick={onConfigClick} onConfigButtonClick={onConfigButtonClick}
                           rippleActive={ripple} onRippleChange={onRippleChange} inputStyle={inputStyle}
                           onInputStyleChange={onInputStyleChange}>

                </AppConfig>

                <AppSearch searchActive={searchActive} onSearchClick={onSearchClick} onSearchHide={onSearchHide}/>

                <div className="layout-mask modal-in">

                </div>
            </div>
        );
    } else if (props.auth.isAuthenticated === false) {
        const host = window.location.host;
        let main_url = "https://ssyz.org.tr/";
        if (host.startsWith("localhost"))
            main_url = "http://localhost:8000/";
        else if (host.startsWith('10.2.6.38')) {
            main_url = "http://10.2.6.38:9000/authorization?token=" + localStorage.getItem('token');
        }
        window.location.replace(main_url)
        return <div></div>;
    } else {
        return (
            <article>
                <div className="p-login-block">
                    <Spinner loadingState={true}/>
                </div>
            </article>

        );
    }
}

const mapStateToProps = props => {
    const auth = props.auth;
    return {
        auth: props.auth,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        loadUser: () => {
            return dispatch(auth.loadUser());
        }
    }
}

let RootContainer = connect(mapStateToProps, mapDispatchToProps)(RootContainerComponent);

export default class App extends Component {
    render() {
        return (
            <Provider store={store}>
                <RootContainer/>
            </Provider>
        )
    }
}




// WEBPACK FOOTER //
// ./src/App.js